import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/integrations/strava")({
  component: () => {
    return <Outlet />;
  },
  staticData: {
    getBreadcrumb({ pathname }) {
      const isExact = pathname === "/settings/integrations/strava";
      return {
        href: "/settings/integrations/strava",
        label: isExact ? undefined : "Strava",
      };
    },
  },
});
